import React, { useState } from 'react'
import Swal from 'sweetalert2'
import apiClient, { API_ENDPOINTS } from '../../config/api'

const AddCategories = () => {
  const [formData, setFormData] = useState({
    name: ''
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Prepare payload according to backend expectations
      // Backend CategorySerializer only expects 'name' field
      const payload = {
        name: formData.name.trim()
      }

      await apiClient.post(API_ENDPOINTS.CATEGORIES, payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Category created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: ''
      })
    } catch (error) {
      console.error('Error creating category:', error)
      const errorMessage = error.response?.data?.name?.[0] || 
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create category. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Categories</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Categories</li>
            <li className="breadcrumb-item active">Add Categories</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-tags me-2"></i>
                  Add New Category
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Category Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter category name"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Category
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddCategories

